import React, { useContext } from 'react'
import { Loading } from '@yoti/ui-kit-components-react/loading'
import { ShareDetailsContext } from '../../providers/ShareDetails'
import HeaderSection from './HeaderSection'
import InstructionsSection from './InstructionsSection'
import ShareSection from './ShareSection'
import CompanySection from './CompanySection'
import FaqSection from './FaqSection'
import FooterSection from './FooterSection'
import './LearnMore.scss'

// NOTE: One can include TypoTemp to check the typography in use
// ie:
// import TypoTemp from './TypoTemp'
// <><TypoTemp />...<>


const LearnMore = () => {
  const {
    application, scenario, features, locale, device
  } = useContext(ShareDetailsContext)

  if (!application) {
    return (
      <div className="learn-more__loading">
        <Loading />
      </div>
    )
  }

  const {
    applicationName,
    applicationLogoUrl,
    applicationVerified,
    applicationReferringWebsite,
    clientSdkId
  } = application
  const { scenarioId, policyAttributes } = scenario
  const { qrCode: hasQrCodeFeature, appLink: hasAppLinkFeature } = features
  const qrCodeDisplayed = !hasAppLinkFeature && hasQrCodeFeature

  return (
    <>
      <HeaderSection
        name={applicationName}
        logoUrl={applicationLogoUrl}
        verified={applicationVerified}
        referringWebsite={applicationReferringWebsite}
      />
      <InstructionsSection
        qrCodeDisplayed={qrCodeDisplayed}
        policyAttributes={policyAttributes}
        device={device}
      />
      <ShareSection
        qrCodeDisplayed={qrCodeDisplayed}
        clientSdkId={clientSdkId}
        scenarioId={scenarioId}
        locale={locale}
        referringWebsite={applicationReferringWebsite}
      />
      <CompanySection device={device} />
      <FaqSection />
      <FooterSection />
    </>
  )
}

export default LearnMore
